import { Box, SimpleGrid, Stack, Text, Title, Group, Badge } from "@mantine/core";
import { artist } from "@/content/artist";
import { photos } from "@/content/photos";
import { releases } from "@/content/releases";
import { MediaImage } from "@/components/common/MediaImage";
import { PageHero } from "@/components/layout/PageHero";
import { PageContainer } from "@/components/layout/PageContainer";

export default function About() {
  const pressPhotos = photos.filter((p) => p.tags.includes("press"));

  return (
    <>
      <PageHero title="About" />
      <PageContainer navOffset={false}>
        <Stack gap="xl">
          <Stack gap="md" maw={760}>
            {artist.longBio.split("\n\n").map((para, i) => (
              <Text key={i} size="md" c="var(--color-foam)" fs="italic">
                {para}
              </Text>
            ))}
          </Stack>

          <Group gap="lg">
            {artist.basedIn && (
              <Box>
                <Text size="xs" tt="uppercase" c="dimmed">
                  Based in
                </Text>
                <Text>{artist.basedIn}</Text>
              </Box>
            )}
            <Box>
              <Text size="xs" tt="uppercase" c="dimmed">
                Genres
              </Text>
              <Group gap="xs">
                {artist.genres.map((g) => (
                  <Badge key={g} variant="light" color="indigo">
                    {g}
                  </Badge>
                ))}
              </Group>
            </Box>
            <Box>
              <Text size="xs" tt="uppercase" c="dimmed">
                Releases
              </Text>
              <Text>{artist.totalReleases ?? releases.length} total</Text>
            </Box>
          </Group>

          <Box>
            <Title order={2} size="h3" mb="sm">
              photos
            </Title>
            {pressPhotos.length > 0 ? (
              <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
                {pressPhotos.map((p) => (
                  <MediaImage
                    key={p.slug}
                    image={p}
                    style={{
                      width: "100%",
                      height: "auto",
                      aspectRatio: "16 / 9",
                      objectFit: "cover",
                      borderRadius: 8,
                    }}
                    sizes="(min-width: 768px) 33vw, 100vw"
                  />
                ))}
              </SimpleGrid>
            ) : (
              // Tasteful placeholder until real press photos land — three
              // dashed cards with an iridescent sweep, middle one captioned.
              // .photo-skeleton + animation lives in global.css.
              <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
                {[0, 1, 2].map((i) => (
                  <Box
                    key={i}
                    className="photo-skeleton"
                    style={{
                      aspectRatio: "16 / 9",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "var(--mantine-spacing-md)",
                    }}
                  >
                    {i === 1 && (
                      <Text
                        size="sm"
                        c="dimmed"
                        fs="italic"
                        ta="center"
                        style={{ position: "relative", zIndex: 1 }}
                      >
                        Hunting down photos to add.. come back soon!
                      </Text>
                    )}
                  </Box>
                ))}
              </SimpleGrid>
            )}
          </Box>
        </Stack>
      </PageContainer>
    </>
  );
}
